import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Layout from '@components/layout';
import SEO from '@components/seo';
import moduleHeroConductor from '@modules/hero-module/module-hero-conductor';
import moduleConductor from '@modules/module-conductor';

const Transformation = ({ location, data }) => {
  const {
    pageData: { seo, slug, contentful_id, hero, footer, sections },
    insightQuery,
    breadcrumbList
  } = data;

  const heroSection = hero && moduleHeroConductor(hero, hero.type);
  const insights = insightQuery && insightQuery.nodes;
  const breadcrumbs = breadcrumbList && breadcrumbList.nodes;

  let extraProps = {
    pageSlug: slug,
    totalCount: sections?.length,
    pageContentfulId: contentful_id,
  };

  const modules =
    sections &&
    sections.map((module, index) => {
      if (module.__typename === 'ContentfulModuleGlobalItem') {
        if (module.type === 'insight-slide') {
          const newProps = { data: insights };
          return moduleConductor(module, index, newProps);
        }
      }
      return moduleConductor(module, index, extraProps);
    });

  return (
    <Layout location={location} footer={footer}>
      {seo && <SEO data={seo} location={location} breadcrumbs={breadcrumbs} />}
      {heroSection}
      {modules}
    </Layout>
  );
};

Transformation.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default Transformation;

export const pageQuery = graphql`
  {
    pageData: contentfulTemplatePage(contentful_id: { eq: "5nYNleUokGNLy9GwyCFz65" }) {
      id
      contentful_id
      slug
      url
      seo {
        ...GlobalSEOFragment
      }
      hero {
        ...ModuleHeroFragment
      }
      subMenuType
      sections {
        ...ModuleOneColumnFragment
        ...ModuleTwoColumnCardsFragment
        ...ModuleServiceListFragment
        ...ModuleAdSectionFragment
        ...ModuleTopicsFragment
        ...ModuleResultsFragment
        ...ModuleAnimationSlideFragment
        ...ModuleMultiCardFragment
        ...ModuleHeaderFragment
        ...ModuleGlobalItemFragment
        ...ModuleImageTextFragment
        ...ModuleTransformationQuizFragment
      }
      footer
    }
    insightQuery: allContentfulTemplateInsight(
      limit: 15
      sort: { fields: publishDate, order: DESC }
    ) {
      nodes {
        ...GlobalInsightFragment
      }
    }
    breadcrumbList: allContentfulSeo(
      filter: { pageUrl: { regex: "^?:/(what-we-do/$)|(what-we-do/transformation/$)/" } }
    ) {
      nodes {
        pageUrl
        pageTitle
      }
    }
  }
`;
